<div class="activity-back-button d-flex justify-content-center" (click)="activityService.navigateToUrl('order-summary')">
    <div class="d-flex align-items-center activity-description-bold">
        <mat-icon>arrow_back</mat-icon>
    </div>
</div>
<div class="page-title-section row px-3 m-0 pt-5 pb-4 flex-column">
    <div class="main-title secondary-theme-color d-flex justify-content-center text-center">{{'checkOut' | translate}}</div>
    <div class="mt-3 sub-title main-theme-color d-flex justify-content-center text-center">{{'proceedWithPaymentToFinalizeTheBooking' | translate}}

    </div>
</div>
<div class="container">
    <div class="row">
        <div class="col-lg-5 col-md-12 col-sm-12 col-12 d-flex flex-column">
            <!-- Authrize IFrame -->
        </div>
        <div class="p-0 col-lg-7 col-md-12 col-sm-12 col-12">
            <!-- Add multi to show multiple expansion parallely or only one expansion to be open at a time -->
            <mat-accordion multi="true" class="activity-accordian-accordian">
                <!-- Remove disabled when having more than 1 slot bookings -->
                <mat-expansion-panel hideToggle expanded="true" disabled=true class="my-3 activity-accordian-panel">
                    <mat-expansion-panel-header class="activity-panel-header">
                        <div
                            class="w-100 order-summary-short-detail-section p-3 mx-2 shadow d-flex flex-row justify-content-between">
                            <div
                                class="guest-count activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
                                <mat-icon>person</mat-icon>
                                <div class="px-2">2 {{'people' | translate}}</div>
                            </div>
                            <div class="order-summary-spacer"></div>
                            <div
                                class="activity-selected-date activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
                                <mat-icon>calendar_today</mat-icon>
                                <div class="px-2">12/23/2021</div>
                            </div>
                            <div class="order-summary-spacer"></div>
                            <div
                                class="activity-selected-time activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
                                <mat-icon>access_time</mat-icon>
                                <div class="px-2">10:00 AM - 11:00 AM</div>
                            </div>
                            <div class="order-summary-spacer"></div>
                            <div
                                class="activity-location activity-description-bold d-flex flex-wrap justify-content-center align-items-center">
                                <mat-icon> location_on</mat-icon>
                                <div class="px-2">2A</div>
                            </div>
                        </div>
                    </mat-expansion-panel-header>
                    <div class="price-splitup-section">
                        <div class="p-0 col-12 price-splitup-table d-flex flex-column">
                            <div class="py-1 price-table-header d-flex flex-row">
                                <div class="p-0 col">
                                    <div class="activity-description-bolder">{{'description' | translate}}</div>
                                </div>
                            </div>
                            <div class="py-1 price-table-data-cell d-flex flex-row">
                                <div class="p-0 col-lg-8 col-md-8 col-sm-8 col-8">
                                    <div class="activity-description-bold">{{'sessionCharges' | translate}} X 2</div>
                                </div>
                                <div class="p-0 col-lg-4 col-md-4 col-sm-4 col-4">
                                    <div class="activity-description-bold">$67.00</div>
                                </div>
                            </div>
                            <div class="my-4 py-3 order-summary-total-price d-flex flex-row justify-content-end">
                                <div class="p-0 col-lg-8 col-md-8 col-sm-8 col-8">
                                    <div class="activity-description-bolder">{{'totalCharges' | translate}}</div>
                                </div>
                                <div class="p-0 col-lg-4 col-md-4 col-sm-4 col-4">
                                    <div class="activity-description-bolder">$154</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <div class="py-4 m-2 order-summary-grand-total d-flex flex-row justify-content-end">
                <div class="p-0 col-lg-6 col-md-6 col-sm-6 col-6">
                    <div class="activity-title">{{'grandTotal' | translate}}</div>
                </div>
                <div class="p-0 col-lg-2 col-md-2 col-sm-2 col-2">
                    <div class="activity-title">$154</div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mx-0 my-5 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
        <div class="col-lg-3 col-md-3 col-sm-6 col-6">
            <div class="activity-buttons m-3 p-3 text-center" (click)="activityService.navigateToUrl('confirmation')">
                {{'submit' | translate}}
            </div>
        </div>
    </div>
</div>